import { cn } from '../../lib/cn';

interface SkeletonProps {
  className?: string;
  /** Aria-hidden by default; add label when this skeleton represents distinct content. */
  label?: string;
}

/**
 * Loading placeholder. Motion-safe animate-pulse only; reduced-motion users
 * see a static tint (Tailwind `motion-safe:` handles this).
 */
export function Skeleton({ className, label }: SkeletonProps): JSX.Element {
  return (
    <div
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn(
        'rounded-tight bg-paper-sunk motion-safe:animate-pulse',
        className,
      )}
    />
  );
}
